import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";

import React, { useState, useEffect, useRef, useContext } from "react";

/* ################ IMPORTS OF PRIMEREACT ################*/
import { DataTable } from "primereact/datatable";
import { RadioButton } from "primereact/radiobutton";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { Toolbar } from "primereact/toolbar";
import { Dropdown } from "primereact/dropdown";
import { Link } from "react-router-dom";
import { EnvContext } from "../Context/EnvProvider";
import ErrorsConfigIntegration from "../../integrations/ErrorsConfigIntegration";
import { useAuthToken } from "../../hooks/useAuthToken";
import useQuery from "../../hooks/useQuery";

const errorsConfigIntegration = new ErrorsConfigIntegration();

const ErrorsConfig = () => {
  let emptyError = {
    errorCode: "",
    description: "",
    actionError: "",
    contextName: "",
    notes: "",
  };
  const [error, setError] = useState(emptyError);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [errors, setErrors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState();
  const [errorCodes, setErrorCodes] = useState([]);
  const [errorsDialog, setErrorsDialog] = useState(false);
  const [deleteErrorsDialog, setDeleteErrorsDialog] = useState(false);
  const dt = useRef(null);
  const query = useQuery();

  const { getAccessToken } = useAuthToken();

  const toast = useRef(null);
  const { environment } = useContext(EnvContext);

  useEffect(() => {
    const templateId = query.get("templateId");
    const loadData = async () => {
      try {
        const authToken = await getAccessToken();

        const data = await errorsConfigIntegration.listErrorsConfig(environment.agendaApi, templateId, authToken);
        if (data.errorConfig) {
          setErrors(data.errorConfig);
        } else {
          setErrors([]);
        }
        setLoading(false);

        const codes = await errorsConfigIntegration.getAllErrorCodes(environment.agendaApi, templateId, authToken);
        if (codes) {
          setErrorCodes(codes);
        } else {
          setErrorCodes([]);
        }
      } catch (err) {
        console.error(err);
        setLoading(false);
        toast.current?.show({
          severity: "error",
          summary: "Erro!",
          detail: "Erro ao carregar configurações de erros.",
          life: 5000,
        });
      }
    };
    
    loadData();
  }, [environment.agendaApi, getAccessToken, query]);

  const confirmDeleteErrors = (error) => {
    setError(error);
    setDeleteErrorsDialog(true);
  };
  const openNew = () => {
    setError(emptyError);
    setErrorsDialog(true);
  };

  const hideDialog = () => {
    setErrorsDialog(false);
  };
  const hideDeleteErrorsDialog = () => {
    setDeleteErrorsDialog(false);
  };

  const deleteErrors = () => {
    let _errors = errors.filter((val) => val.errorCode !== error.errorCode);
    setErrors(_errors);
    setError(emptyError);
    setDeleteErrorsDialog(false);
    toast.current.show({
      severity: "success",
      summary: "Sucesso!",
      detail: "Configuração de erro excluido!",
      life: 3000,
    });
  };
  const showResponseMessage = (json) => {
    if (json.success) {
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Configuração de Erros salvo com sucesso! ",
        life: 5000,
      });
      setErrorsDialog(false);
    } else {
      toast.current.show({
        severity: "error",
        summary: "Erro!",
        detail: "Erro ao salvar as configurações de Erros!",
        life: 5000,
      });
    }
  };
  const sendErrors = async () => {
    try {
      const authToken = await getAccessToken();
      const templateId = query.get("templateId");
      
      let templateErrors = {
        templateId: templateId,
        errorConfig: [],
      };
      templateErrors.errorConfig = [...errors];
      const json = await errorsConfigIntegration.postErrorsConfig(environment.agendaApi, templateId, templateErrors, authToken);
      showResponseMessage(json);
    } catch (err) {
      toast.current.show({
        severity: "error",
        summary: "Erro!",
        detail: "Erro ao enviar Ação de Erro.",
        life: 5000,
      });
    }
  };

  const saveErrors = () => {
    let _errors = [...errors];
    let _error = { ...error };
    _error.actionError = "$" + _error.actionError + "{" + errorMessage + "}";
    const index = findIndexById(error.errorCode); //errorCode
    if (index >= 0) {
      _errors[index] = _error;
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Erro atualizado",
        life: 3000,
      });
    } else {
      _errors.push(_error);
      toast.current.show({
        severity: "success",
        summary: "Sucesso!",
        detail: "Erro criado",
        life: 3000,
      });
    }
    setErrors(_errors);
    setErrorsDialog(false);
    setError(emptyError);
  };
  const findIndexById = (errorCode) => {
    let index = -1;
    if (errors.length) {
      for (let i = 0; i < errors.length; i++) {
        if (errors[i].errorCode === errorCode) {
          index = i;
          break;
        }
      }
      return index;
    } else return index;
  };
  const editErrors = (error) => {
    let localErrorMessage = "";
    if (error.actionError != null) {
      localErrorMessage = error.actionError.substring(error.actionError.indexOf("{") + 1, error.actionError.indexOf("}"), +1);
      error.actionError = error.actionError.substring(1, error.actionError.indexOf("{"));
    }

    setError({ ...error });
    setErrorMessage(localErrorMessage);
    setErrorsDialog(true);
  };

  const onInputChange = (e, name) => {
    let val;
    if (e.target.type === "checkbox") {
      val = e.target.checked;
    } else {
      val = (e.target && e.target.value) || "";
    }
    let _error = { ...error };
    _error[`${name}`] = val;

    setError(_error);
  };

  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Novo" icon="pi pi-plus" className="p-button-success p-mr-2" onClick={openNew} />
      </React.Fragment>
    );
  };
  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Salvar" icon="pi pi-save" className="p-button-success" onClick={sendErrors} />
      </React.Fragment>
    );
  };
  const deleteUserDataTypesDialogFooter = (
    <React.Fragment>
      <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={hideDeleteErrorsDialog} />
      <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteErrors} />
    </React.Fragment>
  );

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-mr-2" onClick={() => editErrors(rowData)} />
        <Button icon="pi pi-trash" className="p-button-rounded p-button-danger" onClick={() => confirmDeleteErrors(rowData)} />
      </React.Fragment>
    );
  };
  const errorDialogFooter = (
    <React.Fragment>
      <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialog} />

      <Button label="Salvar" icon="pi pi-check" className="p-button-text" type="submit" onClick={saveErrors} />
    </React.Fragment>
  );

  const header = (
    <div
      className="table-header"
      style={{
        justifyContent: "space-between",
        display: "flex",
        alignItems: "center",
      }}
    >
      <h5 className="p-m-0">Procurar Erros</h5>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Procurar..." />
      </span>
    </div>
  );

  return (
    <div>
      <Toast ref={toast} />
      <div className="card">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item active">
              <Link to="/ListBotTemplates">Lista de Templates</Link>
            </li>
            <li className="breadcrumb-item active">
              <span>Configurações de Erros</span>
            </li>
          </ol>
        </nav>
      </div>

      <div className="card">
        <Toolbar className="p-mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
        <DataTable ref={dt} value={errors} emptyMessage="Nenhum dado encontrado!" globalFilter={globalFilter} header={header} responsiveLayout="scroll" loading={loading}>
          <Column headerStyle={{ width: "3rem" }} exportable={false}></Column>
          <Column field="errorCode" header="Código do Erro" sortable style={{ minWidth: "10rem" }}></Column>
          <Column bodyStyle={{ textAlign: "center" }} field="description" header="Descrição" sortable style={{ minWidth: "10rem" }}></Column>
          <Column bodyStyle={{ textAlign: "center" }} field="actionError" header="Ação de Erro" sortable style={{ minWidth: "10rem" }}></Column>
          <Column bodyStyle={{ textAlign: "center" }} field="contextName" header="Nome de Contexto" sortable style={{ minWidth: "10rem" }}></Column>
          <Column bodyStyle={{ textAlign: "center" }} field="notes" header="Obs" sortable style={{ minWidth: "10rem" }}></Column>
          <Column body={actionBodyTemplate} style={{ width: "10rem" }}></Column>
        </DataTable>
      </div>
      <Dialog visible={errorsDialog} style={{ width: "40vw" }} header="Ação de Erro" modal baseZIndex={1300} className="p-fluid" footer={errorDialogFooter} onHide={hideDialog}>
        <div className="p-fluid p-formgrid p-grid">
          <div className="p-field p-col-12">
            <label htmlFor="type">Código do Erro</label>
            <Dropdown value={error.errorCode} options={errorCodes} onChange={(e) => onInputChange(e, "errorCode")} />
          </div>
          <div className="p-field p-col-12">
            <label htmlFor="description">Descrição</label>
            <InputText id="description" value={error.description} onChange={(e) => onInputChange(e, "description")} required />
          </div>
          <div className="p-field p-col-12 p-md-12">
            <h4>Em caso de erro na ação:</h4>
          </div>
          <div className="p-field-radiobutton p-col-12 p-md-5">
            <RadioButton inputId="textToUser" name="textToUser" value="textToUser" onChange={(e) => onInputChange(e, "actionError")} checked={error.actionError === "textToUser"} />
            <label htmlFor="textToUser">Mensagem para Usuário</label>
          </div>
          <div className="p-field-radiobutton p-col-12 p-md-5">
            <RadioButton inputId="textToBot" name="textToBot" value="textToBot" onChange={(e) => onInputChange(e, "actionError")} checked={error.actionError === "textToBot"} />
            <label htmlFor="textToBot">Mensagem para o bot</label>
          </div>
          <div className="p-field-radiobutton p-col-12 p-md-2">
            <RadioButton inputId="event" name="event" value="event" onChange={(e) => onInputChange(e, "actionError")} checked={error.actionError === "event"} />
            <label htmlFor="event">Evento</label>
          </div>
          <div className="p-field p-col-12 p-md-12">
            <label htmlFor="message">Mensagem ou Evento</label>
            <InputText id="message" value={errorMessage} onChange={(e) => setErrorMessage(e.target.value)} />
          </div>
          <div className="p-field p-col-12">
            <label htmlFor="contextName">Nome de contexto</label>
            <InputText id="contextName" value={error.contextName} onChange={(e) => onInputChange(e, "contextName")} required />
          </div>
          <div className="p-field p-col-12">
            <label htmlFor="notes">Observações</label>
            <InputText id="notes" value={error.notes} onChange={(e) => onInputChange(e, "notes")} required />
          </div>
        </div>
      </Dialog>

      <Dialog visible={deleteErrorsDialog} style={{ width: "450px" }} header="Confirme" modal footer={deleteUserDataTypesDialogFooter} onHide={hideDeleteErrorsDialog}>
        <div className="confirmation-content">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
          {error && (
            <span>
              Tem certeza de que deseja excluir a Configuração de Erro: <b>{error.errorCode}</b>?
            </span>
          )}
        </div>
      </Dialog>
    </div>
  );
};
export default ErrorsConfig;
